<template>
  <div class="nav-bar">
    <div id="close-btn" style="position: absolute;" @click="closeIframe"
    :style="(currentPageName ==='ChatbotPage' && iframeProperty.layout === 'widget') ? { color: iframeProperty.buttonTextColour } : {}"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14"/></svg>
    </div>
  </div>
  <router-view></router-view>
  <MyToast position="top-right" />
</template>

<script>
import { mapState } from "vuex"

export default {
  name: 'App',
  computed: {
    ...mapState({
      iframeProperty: (state) => {
        return state.iframeProperty;
      },
    }),
    currentPageName() {
      return this.$route.name || "Unknown Page";
    },
  },
  methods: {
    closeIframe: () => {
      window.parent.postMessage({ action: 'closeChatBot' }, '*');
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .nav-bar {
    position: relative;

    #close-btn {
      margin-top: 10px;
      position: absolute;
      cursor: pointer;
      z-index: 99;
      top: 0;
      right: 0;
    }
  }
  
}
</style>
